/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Reasoning_Block_TitleInputs */

const es_components_reasoning_block_title = /** @type {(inputs: Components_Reasoning_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razonamiento profundo`)
};

const en_components_reasoning_block_title = /** @type {(inputs: Components_Reasoning_Block_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep reasoning`)
};

/**
* | output |
* | --- |
* | "Deep reasoning" |
*
* @param {Components_Reasoning_Block_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_reasoning_block_title = /** @type {((inputs?: Components_Reasoning_Block_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Reasoning_Block_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_reasoning_block_title(inputs)
	return en_components_reasoning_block_title(inputs)
});
export { components_reasoning_block_title as "components.reasoning_block.title" }